
import Vue from 'vue'
import Footer from '@/components/Footer.vue';
import userManager from '@/user-manager';

export default Vue.extend({
    name: 'MainLayout',
    components: {
        Footer
    },
    data() {
        return {
            showNavigationDrawer: false,
            list: [
                { label: "Home", to: process.env.VUE_APP_HELPERAI_OFFICIAL_URL, target: ''},
                { label: "Product", to: "/", target: ''},
                { label: "Partnerships", to: "/#partnerships", target: ''},
                { label: "Contact us", to: "mailto:" + process.env.VUE_APP_HELPERAI_CONTACT_EMAIL, target: '_blank'}
            ]
        };
    },
    computed: {
        typeFormUrl() {
            const url = new URL(process.env.VUE_APP_CONTACT_US_TYPEFORM || 'https://ws.namecard.ai/intro?src=home');
            url.searchParams.set('src', 'home_nav');
            return url.href;
        },
        namecardWSUrl() {
            return process.env.VUE_APP_NAMECARD_WORKSPACE_URL;
        },
        bniNonLoginUrl() {
            return process.env.VUE_APP_BNI_NON_LOGIN_URL;
        }
    },
    methods: {
        async login() {
			userManager.signinRedirect();
		},
    }
})
